import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import ModulePropertiesPane from '../_MODULE/ModulePropertiesPane.jsx'
import Model from './ModelCm.mjs'

export default function PropertiesPaneCm(props) {
    return (
        <ModulePropertiesPane
            controllers={
                <>
                    <Text prop="cmUserCode" />
                    <Text prop="cmName" />
                </>
            }

            Model={Model}

            snSuffix={
                <Analyse
                    modes={[
                        'Reference',
                        'ReferenceCall',
                        'IsrfReference',
                    ]}
                />
            }

            versionLabel="用例地图版本号"
            {...props}
        />
    )
}
